import { canViewAnalytics } from "../predicates";
import type { TourStepConfig } from "../../types/tour.types";

export const insightsSteps: TourStepConfig[] = [
  {
    id: "insights-chart",
    target: "insights.chart",
    reveal: {
      trigger: "insights.workflowTab",
      awaits: "insights.chart",
    },
    title: "Workflow chart",
    content:
      "Your requests plotted by status across a date range, so a slow week or a sudden spike is obvious at a glance.",
    placement: "bottom",
    when: canViewAnalytics,
  },
  {
    id: "insights-total-progress",
    target: "insights.totalProgress",
    reveal: {
      trigger: "insights.distributionTab",
      awaits: "insights.totalProgress",
    },
    title: "Completion funnel",
    content:
      "How many requests reach each stage, and how many never make it past one — the quickest way to see where documents stall.",
    placement: "bottom",
    when: canViewAnalytics,
  },
  {
    id: "insights-request-status",
    target: "insights.requestStatus",
    reveal: {
      trigger: "insights.distributionTab",
      awaits: "insights.requestStatus",
    },
    title: "Status distribution",
    content:
      "The same requests split by status, so you can tell a healthy backlog from a stuck one at a glance.",
    placement: "bottom",
    when: canViewAnalytics,
  },
];

export default insightsSteps;
